import { useEffect } from "react";
import "./AtivarModal.css";

export default function AtivarModal({ open, titulo, onClose, onConfirmar }) {
  if (!open) return null;

  // trava scroll do body enquanto o modal está aberto
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  // atalhos: Esc fecha, Enter confirma
  const handleKeyDown = (e) => {
    if (e.key === "Escape") onClose?.();
    if (e.key === "Enter") onConfirmar?.();
  };

  return (
    <div className="atvmd-bg" onKeyDown={handleKeyDown}>
      <div className="atvmd-box" role="dialog" aria-modal="true" aria-label="Ativar registro">
        <header className="atvmd-head">
          <h3 className="atvmd-title">Ativar</h3>
          <button className="atvmd-x" onClick={onClose} type="button" aria-label="Fechar">×</button>
        </header>

        <div className="atvmd-body">
          Deseja <strong>ativar</strong> “{titulo || "este item"}”?
        </div>

        <footer className="atvmd-foot">
          <button className="atvmd-btn" type="button" onClick={onClose}>Cancelar</button>
          <button className="atvmd-btn atvmd-btn-ok" type="button" onClick={onConfirmar}>Ativar</button>
        </footer>
      </div>
    </div>
  );
}
